const C = {
  name: "Sliders1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.874 7C18.4299 5.27477 16.8638 4 15 4C13.1362 4 11.5701 5.27477 11.126 7H2V9L11.126 9C11.5701 10.7252 13.1362 12 15 12C16.8638 12 18.4299 10.7252 18.874 9H22V7H18.874ZM17 8C17 9.10457 16.1046 10 15 10C13.8954 10 13 9.10457 13 8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8Z" fill="currentColor"/>
<path d="M6 12C7.86384 12 9.42994 13.2748 9.87398 15H22V17H9.87398C9.42994 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM8 16C8 14.8954 7.10457 14 6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Sliders1
};
